<template>
    <div class="l-section l-section--main o-checkout">
        <div
            class="l-container l-container--main o-checkout__mainContainer"
            v-if="customer"
        >
            <div class="l-row o-checkout__columns">
                <div class="l-row__column l-row__column--8">
                    <div class="o-checkout__content a-mobile">
                        <div class="l-row l-row--wrap">
                            <div class="l-row__column l-row__column--12">
                                <h2 class="a-title">Uzupełnij dane</h2>
                                <h3 class="a-title a-title--subtitle">Dane do faktury</h3>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    label="Nazwa Firmy"
                                    v-model="companyName"
                                    id="control-companyName"
                                    ref="companyName"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="NIP"
                                    v-model="vatin"
                                    id="control-vatin"
                                    ref="vatin"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Ulica"
                                    v-model="street"
                                    id="control-street"
                                    ref="street"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Miasto"
                                    v-model="city"
                                    id="control-city"
                                    ref="city"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Kod pocztowy"
                                    v-model="postcode"
                                    id="control-postcode"
                                    ref="postcode"
                                />
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <h3 class="a-title a-title--subtitle">Osoba kontaktowa</h3>
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Imię"
                                    v-model="contactPersonFirstName"
                                    id="control-contactPersonFirstName"
                                    ref="contactPersonFirstName"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Nazwisko"
                                    v-model="contactPersonLastName"
                                    id="control-contactPersonLastName"
                                    ref="contactPersonLastName"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    type="mask"
                                    :mask="'+48#########'"
                                    label="Telefon"
                                    placeholder="np. +48987654321"
                                    v-model="contactPersonPhone"
                                    id="control-contactPersonPhone"
                                    ref="contactPersonPhone"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Adres e-mail"
                                    v-model="contactPersonEmail"
                                    id="control-contactPersonEmail"
                                    ref="contactPersonEmail"
                                />
                            </div>
                            <div class="l-row__column l-row__column--6">
                                <a-control
                                    label="Chcę fakturę elektroniczną"
                                    type="checkbox"
                                    :checked="true"
                                    id="control-invoice-email-check"
                                    @input="isEinvoice = $event !== 'true' ? '1' : '0'"
                                    :value="isEinvoice === '1' ? true : false"
                                />
                                <br v-if="isEinvoice === '1'" />
                                <a-control
                                    label="E-mail do wysyłki faktur"
                                    v-if="isEinvoice === '1'"
                                    v-model="einvoice"
                                    id="control-einvoice"
                                    ref="einvoice"
                                />
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    label="Uwagi do faktur"
                                    v-model="einvoiceRemarks"
                                    id="control-einvoice-remarks"
                                    ref="einvoice"
                                    :maxlength="64"
                                />
                                <p class="o-checkout__invoicePopup">
                                    <span class="o-checkout__infoIcon">
                                        <svg width="12" height="12" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)" fill="#fff"><path d="M0 6.614c.207-.394.276-.772.483-.854 1.103-.443 2.224-.886 3.465-.64 1.259.247 1.914 1.018 1.724 2.216-.19 1.149-.551 2.265-.827 3.397-.12.509-.293 1.001-.38 1.51-.19 1.132.294 1.559 1.5 1.362.225-.033.449-.082.673-.115.069.05.12.115.19.164-.259.263-.466.624-.776.772-.983.443-2.018.755-3.138.508-1.259-.279-1.948-1.017-1.759-2.215.207-1.28.604-2.527.931-3.791.104-.443.242-.903.293-1.346.087-.935-.362-1.296-1.345-1.149-.275.033-.551.082-1.034.18zM5.172 0C6.26.05 7.07.87 7 1.855c-.069.968-.966 1.657-2.069 1.608-1.034-.05-1.862-.837-1.845-1.773C3.121.706 4.052-.05 5.172 0z"></path></g><defs><clipPath id="clip0"><path d="M0 0h7v15H0V0z" fill="#fff"></path></clipPath></defs></svg>
                                    </span>
                                    <span class="o-checkout__infoPopup">
                                        Tu możesz wpisać nr zamówienia / nr PO.<br /><br />
                                        Wszystkie zamówieniaktóre złożysz z tym samym nr PO będą zagregowane w jednej fakturze.
                                    </span>
                                </p>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <h2 class="a-title">Szczegóły dostawy</h2>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <m-accordion
                                    :title="`${address.street} ${address.number}, ${address.postcode} ${address.city}`"
                                    v-for="(address, addressIdx) in customerAddresses"
                                    v-bind:key="addressIdx"
                                    :visible="addressVisible[addressIdx]"
                                    :ref="`address-${addressIdx}`"
                                >
                                    <!-- <div class="l-row l-row--nested">
                                        <div class="l-row__column l-row__column--6">
                                            <a-control
                                                label="Piętro"
                                                placeholder="np. III"
                                                :id="`control-address-${addressIdx}-floor`"
                                            />
                                        </div>
                                    </div> -->
                                    <o-notifications
                                        :is-static="true"
                                        :name="`control-address${addressIdx}-delivery`"
                                    />
                                    <label class="a-label a-control__label">
                                        Godziny dostaw
                                    </label>
                                    <select
                                        class="a-select"
                                        :value="deliveryHoursIds[addressIdx]"
                                        @input="setDeliveryHoursId(addressIdx, $event.target.value)"
                                        :name="`control-deliveryHours${deliveryHoursIds[addressIdx]}`"
                                        :id="`control-deliveryHours${deliveryHoursIds[addressIdx]}`"
                                    >
                                        <option value="-1">-- wybierz opcję --</option>
                                        <option
                                            v-for="deliveryHour in deliveryHours"
                                            v-bind:key="deliveryHour.id"
                                            :value="deliveryHour.id"
                                        >{{ deliveryHour.name }} ({{ deliveryHour.remarks }})</option>
                                    </select>
                                    <div class="l-row l-row--nested l-row--wrap">
                                        <div class="l-row__column l-row__column--12">
                                            <a-control
                                                label="Uwagi dla dostawcy"
                                                placeholder="Wpisz"
                                                :value="address.remarks"
                                                @input="setCustomerAddressField(addressIdx, 'remarks', $event)"
                                                :id="`control-address${addressIdx}remarks`"
                                                type="textarea"
                                                rows="4"
                                            />
                                        </div>
                                        <template v-if="address.geometry && address.geometry.lat && address.geometry.lng">
                                            <GmapMap
                                                if="mapDiv"
                                                class="a-control__map"
                                                :center="address.geometry"
                                                :zoom="15"
                                                map-type-id="terrain"
                                                ref="gmap"
                                            >
                                                <GmapMarker
                                                    :position="address.geometry"
                                                    :clickable="true"
                                                    :draggable="true"
                                                    @dragend="updateCoordinates($event, addressIdx)"
                                                />
                                            </GmapMap>
                                        </template>
                                    </div>
                                </m-accordion>
                            </div>
                            <div
                                class="l-row__column l-row__column--12"
                                ref="payment"
                            >
                                <div
                                    v-if="beforeCheckoutMessage"
                                    class="o-notifications o-notifications--static o-checkout__notification"
                                >
                                    <article
                                        class="o-notifications__notification o-notifications__notification--success"
                                    >
                                        <div class="o-notifications__notificationBody">
                                            <p class="o-checkout__notificationText">
                                                {{ beforeCheckoutMessage }}
                                            </p>
                                        </div>
                                    </article>
                                </div>
                                <div>
                                    <br /><br />
                                    <h2 class="a-title">Zamów abonament</h2>
                                    <a-control
                                        class="a-control--hasPaddings"
                                        id="subscription"
                                        type="radio"
                                        name="paymentMethods"
                                        value="subscription"
                                        @input="paymentSymbol = 'subscription'"
                                    >
                                        <div>
                                            <svg class="o-checkout__paymentIcon" width="65" height="49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".8" y=".8" width="52.4" height="33.5" rx="5.2" stroke="#737373" stroke-width="1.6"/><path stroke="#737373" stroke-width="1.6" d="M.8 8.9h52.4v6.5H.8z"/><path fill="#737373" d="M7.2 21.6h23.4v1.6H7.2zM7.2 27.9h18v1.6h-18z"/><circle cx="51" cy="35" r="13.2" fill="#fff" stroke="#737373" stroke-width="1.6"/><rect x="43.825" y="29.8" width="14.4" height="12.4" rx="1.2" stroke="#737373" stroke-width="1.6"/><mask id="a" fill="#fff"><path d="M46.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z"/></mask><path d="M46.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z" stroke="#737373" stroke-width="3" mask="url(#a)"/><mask id="b" fill="#fff"><path d="M52.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z"/></mask><path d="M52.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z" stroke="#737373" stroke-width="3" mask="url(#b)"/><path stroke="#737373" stroke-width="1.6" d="M43.025 33.2h12"/></svg>
                                        </div>
                                        <div>
                                            <p><span>Abonament</span></p>
                                            <p>
                                                Płatność za miniony miesiąc. Faktura wystawiana jest jest zbiorczo pod koniec każdego miesiąca kalendarzowego.
                                            </p>
                                        </div>
                                    </a-control>
                                </div>
                                <o-notifications
                                    :is-static="true"
                                    name="control-payment"
                                />
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    v-for="(term, termIdx) in terms"
                                    v-bind:key="term.symbol"
                                    type="checkbox"
                                    class="a-control--hasPaddings"
                                    :id="`control-terms-${term.symbol}`"
                                    @input="termClick($event, termIdx)"
                                    :value="acceptedTerms[termIdx]"
                                    :ref="`terms-${term.symbol}`"
                                >
                                    <p v-html="term.description"></p>
                                </a-control>
                            </div>
                            <div class="l-row__column l-row__column--12 o-checkout__buttons a-mobile__buttons">
                                <button
                                    class="a-button a-mobile__button"
                                    @click="backToCart"
                                >
                                    Powrót do oferty
                                </button>
                                <a-button
                                    type="submit"
                                    class="a-button a-button--secondary a-mobile__button"
                                    @click="handleSubmit"
                                    :is-processing="orderStatus !== 'idle'"
                                    :disabled="orderStatus !== 'idle'"
                                >
                                    Akceptuję
                                    <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </a-button>
                                <form
                                    :action="orderPaymentUrl"
                                    method="post"
                                    class="o-checkout__paymentForm"
                                >
                                    <input
                                        type="hidden"
                                        name="additionalParams[slug]"
                                        :value="orderSlug"
                                    >
                                    <input
                                        type="hidden"
                                        name="additionalParams[direct]"
                                        :value="paymentSymbol === 'transfer' ? 1 : 0"
                                    >
                                    <input
                                        type="hidden"
                                        name="continueUrl"
                                        :value="orderContinueUrl"
                                    >
                                    <button
                                        id="pay-button"
                                        type="submit"
                                        name="button"
                                    ></button>
                                </form>
                            </div>
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="control-summary"
                        />
                    </div>
                </div>
                <div class="l-row__column l-row__column--4 o-checkout__summary">
                    <offer-checkout-summary />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OfferCheckoutSummary from '@/components/offer/OfferCheckoutSummary'
import MAccordion from '@/components/MAccordion'
import { gmapApi } from 'gmap-vue'
export default {
    metaInfo: {
        title: 'Podsumowanie'
    },
    components: {
        OfferCheckoutSummary,
        MAccordion
    },
    data() {
        return {
            paymentSymbol: '',
            acceptedTerms: [],
            addressVisible: [],
            deliveryHoursIds: []
        }
    },
    computed: {
        offerSlug() {
            return this.$route.params.slug
        },
        google: gmapApi,
        customer() {
            return this.$store.getters.customer
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        terms() {
            return this.$store.getters.offerTerms
        },
        paymentMethods() {
            return this.$store.getters.paymentMethods
        },
        orderStatus() {
            return this.$store.getters.orderStatus
        },
        contactPersonFirstName: {
            get() { return this.$store.getters.customer.contactPerson.firstName },
            set(value) { this.$store.dispatch('setCustomerContactPerson', { field: 'firstName', value }) }
        },
        contactPersonLastName: {
            get() { return this.$store.getters.customer.contactPerson.lastName },
            set(value) { this.$store.dispatch('setCustomerContactPerson', { field: 'lastName', value }) }
        },
        contactPersonPhone: {
            get() { return this.$store.getters.customer.contactPerson.phone },
            set(value) { this.$store.dispatch('setCustomerContactPerson', { field: 'phone', value }) }
        },
        contactPersonEmail: {
            get() { return this.$store.getters.customer.contactPerson.email },
            set(value) { this.$store.dispatch('setCustomerContactPerson', { field: 'email', value }) }
        },
        companyName: {
            get() { return this.$store.getters.customer.companyName },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'companyName', value }) }
        },
        vatin: {
            get() { return this.$store.getters.customer.vatin },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'vatin', value }) }
        },
        street: {
            get() { return this.$store.getters.customer.street },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'street', value }) }
        },
        city: {
            get() { return this.$store.getters.customer.city },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'city', value }) }
        },
        postcode: {
            get() { return this.$store.getters.customer.postcode },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'postcode', value }) }
        },
        isEinvoice: {
            get() { return this.$store.getters.customer.isEinvoice },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'isEinvoice', value }) }
        },
        einvoice: {
            get() { return this.$store.getters.customer.einvoice },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'einvoice', value }) }
        },
        einvoiceRemarks: {
            get() { return this.$store.getters.customer.einvoiceRemarks },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'einvoiceRemarks', value }) }
        },
        orderPaymentUrl() {
            return this.$store.getters.orderPaymentUrl
        },
        orderSlug() {
            return this.$store.getters.orderSlug
        },
        orderContinueUrl() {
            return `${window.location.origin}${this.$router.resolve({ name: 'thank-you' }).href}`
        },
        deliveryHours() {
            return this.$store.getters.deliveryHours
        },
        beforeCheckoutMessage() {
            return this.$store.getters.beforeCheckoutMessage
        }
    },
    methods: {
        backToCart() {
            this.$store.dispatch('resetOrderStatus')
            this.$router.push({ name: 'offer-cart', params: { slug: this.$route.params.slug } })
        },
        termClick($event, termIdx) {
            if(this.acceptedTerms[termIdx] !== true) {
                this.$set(this.acceptedTerms, termIdx, true)
            } else {
                this.$set(this.acceptedTerms, termIdx, false)
            }
        },
        updateCoordinates(location, addressId) {
            this.$store.dispatch('setCustomerAddressField', {
                addressId,
                field: 'geometry',
                value: {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng()
                }
            })
        },
        setCustomerAddressField(addressId, field, value) {
            this.$store.dispatch('setCustomerAddressField', {
                addressId,
                field,
                value
            })
        },
        validate(fields) {
            let valid = true
            fields.forEach(([field, content]) => {
                if(this[field] === '' && valid) {
                    this.$scrollTo(this.$refs[field].$el, 500, {
                        offset: -65
                    })
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content,
                        limit: 0,
                        name: `control-${field}`
                    })
                    valid = false
                }
            })
            return !valid
        },
        handleSubmit() {
            const validEmailRegexp = /\S+@\S+\.\S+/
            if(this.validate([
                ['companyName', 'Proszę podać nazwę firmy.'],
                ['vatin', 'Proszę podać NIP firmy.'],
                ['street', 'Proszę podać ulicę.'],
                ['city', 'Proszę podać miasto.'],
                ['postcode', 'Proszę podać postcode.'],
                ['street', 'Proszę podać ulicę.'],
                ['contactPersonFirstName', 'Proszę podać imię osoby kontaktowej.'],
                ['contactPersonLastName', 'Proszę podać nazwisko osoby kontaktowej.'],
                ['contactPersonPhone', 'Proszę podać telefon osoby kontaktowej.'],
                ['contactPersonEmail', 'Proszę podać email osoby kontaktowej.']
            ])) {
                return
            }
            if(this.contactPersonPhone.length !== 12) {
                this.$scrollTo(this.$refs.contactPersonPhone.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij poprawnie numer telefonu',
                    limit: 0,
                    name: 'control-contactPersonPhone'
                })
                return false
            }
            if(!validEmailRegexp.test(this.contactPersonEmail)) {
                this.$scrollTo(this.$refs.contactPersonEmail.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij poprawnie adres e-mail',
                    limit: 0,
                    name: 'control-contactPersonEmail'
                })
                return false
            }
            // validate eInvoice
            if(this.isEinvoice === '1' && !validEmailRegexp.test(this.einvoice)) {
                this.$scrollTo(this.$refs.einvoice.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Uzupełnij poprawnie adres e-mail do faktur',
                    limit: 0,
                    name: 'control-einvoice'
                })
                return false
            }
            // validate address hours
            for(const addressIdx in this.customerAddresses) {
                if(this.deliveryHoursIds[addressIdx] === -1) {
                    this.$scrollTo(this.$refs[`address-${addressIdx}`][0].$el, 500, {
                        offset: -65
                    })
                    this.$set(this.addressVisible, addressIdx, true)
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Podaj godziny dostaw',
                        limit: 0,
                        name: `control-address${addressIdx}-delivery`
                    })
                    return false
                }
            }
            // validate payment
            if(this.paymentSymbol === '') {
                this.$scrollTo(this.$refs.payment, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wybierz rodzaj płatności',
                    limit: 0,
                    name: 'control-payment'
                })
                return false
            }
            // validate terms
            let valid = true
            this.terms.forEach((term, idx) => {
                if(this.acceptedTerms[idx] === undefined || this.acceptedTerms[idx] === false) {
                    this.$scrollTo(this.$refs[`terms-${term.symbol}`][0].$el, 500, {
                        offset: -65
                    })
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Musisz zaakceptowć warunki.',
                        limit: 0,
                        name: `control-terms-${term.symbol}`
                    })
                    valid = false
                    return false
                }
            })
            if(!valid) {
                return false
            }
            // agregate payload
            const store = this.$store.getters
            const payload = {
                slug: this.offerSlug,
                company: {
                    name: this.companyName,
                    city: store.customer.city,
                    address: store.customer.street,
                    postcode: store.customer.postcode,
                    vatin: store.customer.vatin
                },
                invoice: {
                    einvoice: !!this.isEinvoice,
                    email: this.einvoice,
                    remarks: this.einvoiceRemarks
                },
                contact: {
                    first_name: this.contactPersonFirstName,
                    last_name: this.contactPersonLastName,
                    phone: this.contactPersonPhone,
                    email: this.contactPersonEmail
                },
                deliveries: [],
                terms: [],
                confirmed_suggestions: []
            }
            const addresses = []
            for(const idx in this.$store.getters.customerAddresses) {
                const address = this.$store.getters.customerAddresses[idx]
                const newAddress = {
                    ids: address.ids,
                    city: address.city,
                    postcode: address.postcode,
                    address: `${address.street} ${address.number}`,
                    address2: '',
                    hour_from: address.hoursFrom,
                    hour_to: address.hoursTo,
                    earliest_from: address.earliestFrom,
                    remarks: address.remarks,
                    latitude: address.geometry.lat,
                    longitude: address.geometry.lng
                }
                addresses.push(newAddress)
            }
            this.$set(payload, 'deliveries', addresses)
            // terms
            const terms = []
            this.terms.forEach((term, idx) => {
                terms.push({
                    symbol: term.symbol,
                    confirmed: this.acceptedTerms[idx] !== undefined && this.acceptedTerms[idx] !== false
                })
            })
            this.$set(payload, 'terms', terms)
            // confirmed_suggestions
            const confirmedSuggestions = this.$store.getters.weekOrders.filter(item => item.draggable === true).map(item => ({
                id: item.product.id,
                ids: this.$store.getters.customerAddresses[0].ids,
                isodow: item.dayInWeek + 1,
                first_week: item.cycleId
            }))
            this.$set(payload, 'confirmed_suggestions', confirmedSuggestions)
            // submit offer
            this.$store.dispatch('submitOffer', payload).then(() => {
            }).catch(error => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: `Wystąpił nieoczekiwany błąd:<br />${error}`,
                    limit: 0,
                    name: 'control-summary',
                    dontRemove: true
                })
            })
        },
        setDeliveryHoursId(addressIdx, value) {
            this.$set(this.deliveryHoursIds, addressIdx, value)
            this.setCustomerAddressField(addressIdx, 'hoursFrom', this.deliveryHours.find(item => +item.id === +value).hour_from)
            this.setCustomerAddressField(addressIdx, 'hoursTo', this.deliveryHours.find(item => +item.id === +value).hour_to)
            this.setCustomerAddressField(addressIdx, 'earliestFrom', this.deliveryHours.find(item => +item.id === +value).hour_from)
        }
    },
    created() {
        this.$store.dispatch('fetchOfferTerms')
        this.$store.dispatch('fetchDeliveryHours').then(() => {
            for(const addressIdx in this.customerAddresses) {
                if(this.deliveryHours[0] !== undefined) {
                    this.$set(this.deliveryHoursIds, addressIdx, -1)
                }
            }
        })
    }
}
</script>
